import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/analytics-panel-poster.webp")